import React from 'react';
import { Redirect as RouterRedirect } from 'react-router-dom';

const Redirect = ({ to, ...rest }) => {
    if (to && to.startsWith('/')) {
        return <RouterRedirect to={to} {...rest} />;
    }
    window.location = to;
    return null;
};

export default Redirect;
